import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { Slot } from 'expo-router';
import { StatusBar } from 'expo-status-bar';
import * as WebBrowser from 'expo-web-browser';
import { StyleSheet, View } from 'react-native';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import { AnalyticsTracker } from '@/src/components/AnalyticsTracker';
import { CrashlyticsTracker } from '@/src/components/CrashlyticsTracker';
import { ProfileNavigationOverlay } from '@/src/components/ProfileNavigationOverlay';
import { SentryDiagnosticsTracker } from '@/src/components/SentryDiagnosticsTracker';
import { ToastProvider } from '@/src/components/Toast';
import { AppVersionUpdatePrompt } from '@/src/features/app-version/AppVersionUpdatePrompt';
import { AuthProvider } from '@/src/features/auth/auth-context';
import { OfflineSyncProvider } from '@/src/features/offline/OfflineSyncProvider';
import { ForegroundPushHandler } from '@/src/features/pwa/ForegroundPushHandler';
import { queryClient, queryPersister } from '@/src/lib/query-client';
import { initSentry } from '@/src/lib/sentry';
import * as Sentry from '@sentry/react-native';

initSentry();

WebBrowser.maybeCompleteAuthSession();

export default Sentry.wrap(function RootLayout() {
  return (
    <SafeAreaProvider>
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{
          maxAge: 24 * 60 * 60 * 1000,
          persister: queryPersister,
        }}
      >
        <AuthProvider>
          <ToastProvider>
            <OfflineSyncProvider>
              <AnalyticsTracker />
              <CrashlyticsTracker />
              <SentryDiagnosticsTracker />
              <ForegroundPushHandler />
              <AppVersionUpdatePrompt />
              <View style={styles.appRoot}>
                <Slot />
                <ProfileNavigationOverlay />
              </View>
            </OfflineSyncProvider>
          </ToastProvider>
          <StatusBar style="dark" />
        </AuthProvider>
      </PersistQueryClientProvider>
    </SafeAreaProvider>
  );
});

const styles = StyleSheet.create({
  appRoot: {
    flex: 1,
  },
});
